export const cs = {
  shared: {
    chooseImage: 'Vyberte obrázek',
    loadingData: 'Načítám data, vydržte prosím...',
    errorLoadingData: 'Nepodařilo se načíst data! Popis chyby:',
    retry: 'Zkusit znovu'
  }
};
